// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__wRVFI","mainMessage":"ErrorPage_mainMessage__JaXbF","subMessageArea":"ErrorPage_subMessageArea__ChMpc","buttonArea":"ErrorPage_buttonArea__0KMAE"};